import { render, staticRenderFns } from "./ReportImageRemark.vue?vue&type=template&id=18ab0148&"
import script from "./ReportImageRemark.vue?vue&type=script&lang=js&"
export * from "./ReportImageRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSeparator,QItem,QInput,QCardActions,QBtn,QSpace} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QSeparator,QItem,QInput,QCardActions,QBtn,QSpace}, component.options.components || {})
